jQuery(function($){
  
  	$('body').addClass('js');
	var $menu = $('#menu'),
	  	$menulink = $('.menu-link'),
	  	$menulinkbutton = $('.menu-link i'),
	  	$navsocial = $('.nav-social'),
	  	$menuTrigger = $('.has-submenu > a');

	$menulink.click(function(e) {
		e.preventDefault();
		$menulink.toggleClass('active');
		$menu.toggleClass('active');
		$menulinkbutton.toggleClass('fa-times-circle');
		$menulinkbutton.toggleClass('fa-bars');
	});

	$menuTrigger.click(function(e) {
		e.preventDefault();
		var $this = $(this);
		$this.toggleClass('active').next('ul').toggleClass('active');
	});
	
	
	$(".slides").responsiveSlides({
		auto: true,             // Boolean: Animate automatically, true or false
		speed: 500,            // Integer: Speed of the transition, in milliseconds
		timeout: 4000,          // Integer: Time between slide transitions, in milliseconds
		pager: false,           // Boolean: Show pager, true or false
		nav: true,             // Boolean: Show navigation, true or false
		random: false,          // Boolean: Randomize the order of the slides, true or false
		pause: false,           // Boolean: Pause on hover, true or false
		pauseControls: true,    // Boolean: Pause when hovering controls, true or false
		prevText: "Previous",   // String: Text for the "previous" button
		nextText: "Next",       // String: Text for the "next" button
		maxwidth: "",           // Integer: Max-width of the slideshow, in pixels
		navContainer: "",       // Selector: Where controls should be appended to, default is after the 'ul'
		manualControls: "",     // Selector: Declare custom pager navigation
		namespace: "centered-btns",   // String: Change the default namespace used
		before: function(){},   // Function: Before callback
		after: function(){}     // Function: After callback
	});
	
	$('#thumbs').delegate('img','click', function(){
		$('#large-img').attr('src',$(this).attr('src'));
		$('.zoomImg').attr('src',$(this).attr('src'));
		$('#product-large-img').attr('href',$(this).attr('src'));
	});

});